module.exports = __webpack_public_path__ + "img/doc-replace-icon.86bd3e1d.svg";